import React, { useState } from 'react'
import { 
    Menu, 
    Row, 
    Col, 
    Image, 
    Modal,
    Button,
} from 'antd';
import { useNavigate, Link } from "react-router-dom";
import HeaderImage from "../../Assets/alta_logo.png"
import {
    CloseOutlined,
    UnorderedListOutlined,
} from '@ant-design/icons';
import { 
    Autorenew,
    AccountBox, 
    Person,
    CorporateFare,
    ContentPaste,
    AutoAwesomeMosaic,
    MeetingRoom,
    CurrencyExchange,
    CreditScore,
    AddCard,
    Receipt,
} from '@mui/icons-material';
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { refreshPage, getUserRole } from '../../Utils/Common';
import { logout } from "../../Utils/api/Auth";
const { SubMenu } = Menu;

const roleBasedModuleAccess = {
    Admin: [
        "/dashboard",
        "/member",
        "/status",
        "/corporate",
        "/recurring-transaction",
        "/credit",
        "/reports",
        "/credit_sub",
        "/transaction-history",
        "/user",
    ],
    Staff: [
        "/dashboard",
        "/member",
    ],
    Viewer: [
        "/dashboard",
        "/credit-billing-statement",
        "/reports",
    ],
    Member: [
        "/dashboard",
    ],
    Credit_and_collection: [
        "/dashboard",
        "/member",
        "/transaction-history",
    ],
};

function Navbar(props) {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const [subMenu, setSubMenu] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [modal, contextHolder] = Modal.useModal();

    const userRole = getUserRole() ?? "admin";
    const allowedUrls = roleBasedModuleAccess[userRole] || [];

    const toggleCollapsed = () => {
        setIsHovered(!isHovered);
    };

    async function handleLogout() {
        setIsLoading(true);
        await logout();
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('name');
        localStorage.removeItem('role_id');
        localStorage.removeItem('role_name');
        localStorage.removeItem('token_expiry');
        setTimeout(() => {
            navigate("/");
            refreshPage();
        }, 500);
        setIsLoading(false);
    }

    const confirm = () => {
        modal.confirm({
            title: "Are you sure you want to logout?",
            icon: <ExclamationCircleOutlined />,
            content: "",
            okButtonProps: { isLoading },
            okText: "Logout",
            cancelText: "Cancel",
            onOk: handleLogout,
        });
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleToggleSub = (key) => {
        setSubMenu((prevOpenKeys) =>
            prevOpenKeys.includes(key) ? prevOpenKeys.filter((k) => k !== key) : [...prevOpenKeys, key]
        );
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        setSubMenu('');
    };

    return (
        <>
            <Row className='toggle-navbar'>
                <Col span={24} align='right'>
                    <Button
                        onClick={toggleCollapsed}
                        className={isHovered ? 'm-1 toggle-btn cancel-btn' : 'm-1 toggle-btn ok-btn'}
                    >
                        {isHovered ? <CloseOutlined className='pt-2' /> : <UnorderedListOutlined className='pt-2' />}
                    </Button>
                </Col>
            </Row>
            <div
                className={isHovered ? 'navbar-container-hovered responsive-overflow-y' : 'navbar-container navbar-page responsive-overflow-y'}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Row className='mb-2' style={{ background: 'var(--dominant-color)' }}>
                    <Col span={24} className='center'>
                        <Image
                            width="40%"
                            height="auto"
                            src={HeaderImage}
                            alt="login-image"
                            preview={false}
                        />
                    </Col>
                </Row>
                <Row className={isHovered ? 'overflow-y responsive-overflow-y nav-height' : 'nav-height overflow'}>
                    <Col span={24} className='center'>
                        <Menu
                            mode="inline"
                            selectedKeys={props.navKey ? [props.navKey] : []}
                            openKeys={subMenu}
                            inlineCollapsed={!isHovered}
                            className='navbar-menu'
                        >
                            {allowedUrls.includes("/dashboard") && (
                                <Menu.Item key="dashboard" icon={<AutoAwesomeMosaic />} className='center'>
                                    <Link className='link-container' to="/dashboard"><span>Dashboard</span></Link>
                                </Menu.Item>
                            )}
                            {allowedUrls.includes("/member") && (
                                <Menu.Item key="member" icon={<Person />} className='center'>
                                    <Link className='link-container' to="/member"><span>Members</span></Link>
                                </Menu.Item>
                            )}
                            {/* {allowedUrls.includes("/status") && (
                                <Menu.Item key="status" icon={<Autorenew />} className='center'>
                                    <Link className='link-container' to="/status"><span>Change Status</span></Link>
                                </Menu.Item>
                            )} */}
                            {allowedUrls.includes("/corporate") && (
                                <Menu.Item key="corporate" icon={<CorporateFare />} className='center'>
                                    <Link className='link-container' to="/corporate"><span>Corporate</span></Link>
                                </Menu.Item>
                            )}
                            {allowedUrls.includes("/recurring-transaction") && (
                                <Menu.Item key="recurring" icon={<CurrencyExchange />} className='center'>
                                    <Link className='link-container' to="/accounting/recurring-transaction"><span>Recurring Transaction</span></Link>
                                </Menu.Item>
                            )}
                            {/* {allowedUrls.includes("/credit") && (
                                <Menu.Item key="credit" icon={<CreditScore />} className='center'>
                                    <Link className='link-container' to="/credit"><span>Credit</span></Link>
                                </Menu.Item>
                            )} */}
                            {allowedUrls.includes("/reports") && (
                                <SubMenu
                                    key="tenant_report_sub_nav"
                                    icon={<ContentPaste />}
                                    title="Report"
                                    onTitleClick={() => handleToggleSub('tenant_report_sub_nav')}
                                >
                                    <Menu.Item key="member_report">
                                        <Link className='link-container' to="/report/member"><span>Member Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="corporate_report">
                                        <Link className='link-container' to="/report/corporate"><span>Corporate Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            )}
                            {allowedUrls.includes("/credit_sub") && (
                                <SubMenu
                                    key="credit_sub_nav"
                                    icon={<AddCard />}
                                    title="Credit"
                                    onTitleClick={() => handleToggleSub('credit_sub_nav')}
                                >
                                    <Menu.Item key="refundable_deposit">
                                        <Link className='link-container' to="/credit/refundable-deposit"><span>Refundable Deposit</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            )}
                            {(allowedUrls.includes("/credit_sub") || allowedUrls.includes("/transaction-history")) && (
                                <SubMenu
                                    key="accounting_sub_nav"
                                    icon={<Receipt />}
                                    title="Accounting"
                                    onTitleClick={() => handleToggleSub('accounting_sub_nav')}
                                >
                                    {allowedUrls.includes("/credit_sub") && (
                                        <Menu.Item key="credit_billing">
                                            <Link className='link-container' to="/accounting/billing"><span>Billing</span></Link>
                                        </Menu.Item>
                                    )}
                                    {allowedUrls.includes("/credit_sub") && (
                                        <Menu.Item key="credit_payment">
                                            <Link className='link-container' to="/accounting/payment"><span>Payment</span></Link>
                                        </Menu.Item>
                                    )}
                                    {allowedUrls.includes("/transaction-history") && (
                                        <Menu.Item key="transaction-history">
                                            <Link className='link-container' to="/accounting/transaction-history"><span>Transaction History</span></Link>
                                        </Menu.Item>
                                    )}
                                    {allowedUrls.includes("/credit_sub") && (
                                        <Menu.Item key="credit_recurring">
                                            <Link className='link-container' to="/accounting/recurring-transaction"><span>Recurring Transaction</span></Link>
                                        </Menu.Item>
                                    )}
                                </SubMenu>
                            )}
                            {allowedUrls.includes("/user") && (
                                <Menu.Item key="user_nav" icon={<AccountBox />} className='center'>
                                    <Link className='link-container' to="/user"><span>User</span></Link>
                                </Menu.Item>
                            )}
                            <Menu.Item
                                key="login"
                                icon={<MeetingRoom className='logout-icon' />}
                                onClick={confirm}
                                className='center logout-button'
                                align='bottom'
                            >
                                <span>Logout</span>
                            </Menu.Item>
                            {contextHolder}
                        </Menu>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Navbar
